import { Modal } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useBlocker } from "react-router";

const RouterBlocker = ({
  shouldBlockFn,
  shouldShowModal = true,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const blocker = useBlocker(shouldBlockFn);

  if (blocker.state !== "blocked" || !shouldShowModal) return null;

  const handleConfirm = async () => {
    await onConfirm?.();
    blocker.proceed();
  };

  const handleCancel = () => {
    blocker.reset();
  };

  return (
    <Modal
      title={title}
      open={true}
      okText={confirmText || t("global:discardChanges")}
      okType="danger"
      cancelText={cancelText || t("global:cancel")}
      closable={true}
      onOk={handleConfirm}
      onCancel={handleCancel}
    >
      {message}
    </Modal>
  );
};

RouterBlocker.propTypes = {
  shouldBlockFn: PropTypes.func.isRequired, // See type `BlockerFunction` from react-router-dom
  shouldShowModal: PropTypes.bool,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func,
};

export default RouterBlocker;
